
import Swiper from 'swiper/swiper-bundle.min'
import 'swiper/swiper-bundle.min.css'

export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
      colors: ['#F15B22', '#81CAF0', '#665FAA'],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.context(() => {
        // const swipeImages = new Swiper(this.$refs.swiperImage, {
        //   // mousewheel: true,
        //   // direction: 'horizontal',
        //   // loop: true,
        //   effect: 'cube',
        //   // creativeEffect: {
        //   //   prev: {
        //   //     shadow: true,
        //   //     translate: ['-120%', 0, -500],
        //   //   },
        //   //   next: {
        //   //     shadow: true,
        //   //     translate: ['120%', 0, -500],
        //   //   },
        //   // },
        //   cubeEffect: {
        //     shadow: false,
        //     slideShadows: true,
        //     shadowOffset: 20,
        //     shadowScale: 0.94,
        //   },
        //   // grabCursor: true,
        //   keyboard: true,
        //   speed: 800,
        //   // on: {
        //   //   realIndexChange: (swiper) => console.log(swiper.realIndex),
        //   //   init: () => console.log('init images'),
        //   // },
        // })

        const swiperText = new Swiper(this.$refs.swiperImage, {
          // loop: true,
          effect: 'cards',
          cardsEffect: {
            slideShadows: false,
          },
          grabCursor: true,
          keyboard: true,

          mousewheel: {
            enabled: true,
            eventsTarget: '.swiper-image-container',
            releaseOnEdges: true,
            thresholdDelta: 0.5,
            thresholdTime: 150,
            forceToAxis: true,
            invert: false,
            sensitivity: 0.5,
            modifiers: {
              axis: 'x',
              delta: 0.5,
              factor: 1,
              invert: false,
              pixelRatio: 1,
              velocity: 0.3,
            },
          },
          speed: 800,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.summit-bspot-pagination',
            clickable: true,
          },
          on: {
            realIndexChange: (swiper) => {
              // console.log(swiper.realIndex)
              this.currentIndex = swiper.realIndex
            },
            // init: () => console.log('init text'),
          },
        })

        // swiperText.on('mousewheel', (event) => {
        //   if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        //     event.preventDefault()
        //     swiperText.translateTo(
        //       -swiperText.translate + event.deltaX * 2,
        //       0,
        //       0
        //     )
        //   }
        // })
        // swiperText.controller.control = swipeImages
        // swipeImages.controller.control = swiperText
      }, this.$refs.container)
    })
  },
}
